import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TapableTerminalCard } from './component/tapable-terminal-card.component';


@NgModule({
  declarations: [
    TapableTerminalCard
  ],
  exports: [
    TapableTerminalCard
  ],
  imports: [
    CommonModule
  ]
})
export class TapableTerminalCardModule { }
